interface ErrorStateProps {
  error: Error | null;
  onRetry: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  console.log('[ErrorState] Rendering with error:', error?.message, error);

  return (
    <div className="text-center max-w-md mx-auto px-4">
      <div className="mb-6">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
          <svg
            className="w-8 h-8 text-red-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-red-400 mb-2">Test Failed</h2>
        <p className="text-gray-400">
          {error?.message || 'An unexpected error occurred'}
        </p>
      </div>

      <button
        type="button"
        onClick={onRetry}
        className="px-6 py-3 bg-ds-primary hover:bg-ds-primary-dark active:scale-95 active:bg-ds-primary-dark/80 rounded-lg font-medium transition-all duration-100"
      >
        Try Again
      </button>
    </div>
  );
}
